import { render, staticRenderFns } from "./useNameLogin.vue?vue&type=template&id=48c1ab14"
import script from "./useNameLogin.vue?vue&type=script&lang=js"
export * from "./useNameLogin.vue?vue&type=script&lang=js"
import style0 from "./useNameLogin.vue?vue&type=style&index=0&id=48c1ab14&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports